import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function Unauthorized() {
  const [t, i18n] = useTranslation("global");

  return (
    <div style={{ marginTop: "70px" }}>
      {/* <h1>{t("unauth.title")}</h1>
      <p>{t("unauth.text.detail")}</p> */}
      <Typography
        variant="h4"
        fontWeight="bold"
        style={{ marginBottom: "20px" }}
      >
        {t("unauth.title")}
      </Typography>
      <Typography>{t("unauth.text.detail")}</Typography>
    </div>
  );
}
